package gr.tech.GRAttestation.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import gr.tech.GRAttestation.styles.defaultText
import org.jetbrains.compose.web.css.px

@Composable
fun AdminDetailRow(
    rowModifier: Modifier = Modifier,
    name: String,
    value: String
) {
    Row(
        modifier = Modifier.padding(4.px).fillMaxWidth()
            .then(rowModifier),
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        SpanText(
            text = name,
            modifier = Modifier.defaultText().color(Colors.Grey)
        )
        SpanText(
            text = value,
            modifier = Modifier.defaultText().color(Colors.Black)
        )
    }
}